<template>
  <b-container fluid>
    <form>
      <b-row>
        <b-col lg="12">
          <iq-card body-class="p-0">
            <template v-slot:default>
              <div class="iq-edit-list">
                <tab-nav :pills="true" class="iq-edit-profile d-flex">
                  <tab-nav-items class="col-md-4 p-0" :active="true" href="#personal-information" title="Personal Information" />
                  <tab-nav-items class="col-md-4 p-0" :active="false" href="#chang-pwd" title=" Change Password" />
                  <tab-nav-items class="col-md-4 p-0" :active="false" href="#emailandsms" title="Contact Information" />
                </tab-nav>
              </div>
            </template>
          </iq-card>
        </b-col>
        <b-col lg="12">
          <div class="iq-edit-list-data">
            <tab-content id="pills-tabContent-2">
              <tab-content-item :active="true" id="personal-information" >
                <iq-card>
                  <template v-slot:headerTitle>
                    <h4 class="card-title">Personal Information</h4>
                  </template>
                  <template v-slot:default v-if="doctor">
                      <Form @submit="updatePersonalInfo" v-slot="{ errors }">
                      <div class="form-group row align-items-center">
                        <b-col md="12">
                          <div class="profile-img-edit">
                            <img :src="profilePic" class="profile-pic height-150 width-150" alt="profile-pic"/>
                            <my-upload v-if="showUpload" field="img"
                                @crop-success="previewImage"
                                @update:modelValue="toggleShowUpload"
                                :width="150"
                                :height="150"
                                :noSquare="true"
                                img-format="jpg" langType="en">
                            </my-upload>
                            <div class="p-image">
                              <label class="position-relative" for="avatar">
                                <i class="ri-pencil-line upload-button" @click="toggleShowUpload"></i>
                              </label>
                            </div>
                          </div>
                        </b-col>
                      </div>
                      <div class="row">
                          <div class="form-group col-md-6">
                            <label for="firstName">First Name</label>
                            <Field name="firstName" class="form-control mb-0" :class="{ 'is-invalid': errors['firstName']}"
                            id="firstName" type="text" :placeholder="doctor.firstName"/>
                            <div class="invalid-feedback">
                              <ErrorMessage name="firstName" />
                            </div>
                          </div>
                          <div class="form-group col-md-6">
                            <label for="lastName">Last Name</label>
                            <Field name="lastName" class="form-control mb-0" :class="{ 'is-invalid': errors['lastName']}"
                            id="lastName" type="text" :placeholder="doctor.lastName"/>
                            <div class="invalid-feedback">
                              <ErrorMessage name="lastName" />
                            </div>
                          </div>
                      </div>
                      <div class="row">
                          <div class="form-group col-md-6">
                            <label for="position">Position</label>
                            <Field name="position" class="form-control mb-0" :class="{ 'is-invalid': errors['position']}"
                            id="position" type="text" :placeholder="doctor.position"/>
                            <div class="invalid-feedback">
                              <ErrorMessage name="position" />
                            </div>
                          </div>
                          <div class="form-group col-md-6">
                            <label for="gender">Gender</label>
                            <div class="radio">
                              <Field name="gender" type="radio" value="Male"/> Male
                              <Field class="radio-input" name="gender" type="radio" value="Female" /> Female
                            </div>
                            <div class="invalid-feedback">
                              <ErrorMessage name="gender" />
                            </div>
                          </div>
                      </div>
                        <div class="row"><label class="col-md-12" for="specialities">Specialities</label></div>
                        <div v-for="index in numberOfSpecialities" :key="index">
                          <div class="row speciality-row">
                            <div class="form-group col-md-6">
                            <span>Title</span>
                            <input class="form-control" type="text" v-model="inputSpecialities[index-1].title"/>
                          </div>
                          <div class="form-group col-md-6">
                            <span>Short Description</span>
                            <input class="form-control mb-0"
                             type="text" v-model="inputSpecialities[index-1].description"/>
                          </div>
                        </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-2">
                            <button class="speciality-button btn" @click="addAnother">Add another</button>
                          </div>
                          </div>
                      <div class="row">
                          <div class="form-group col-md-12">
                            <label for="address">Address</label>
                            <Field name="address" class="form-control mb-0" :class="{ 'is-invalid': errors['address']}"
                            id="address" type="text" :placeholder="doctor.address"/>
                            <div class="invalid-feedback">
                              <ErrorMessage name="address" />
                            </div>
                          </div>
                      </div>
                      <b-button v-if="!updatePending" type="submit" variant="primary" class="mr-2 ml-3">Update</b-button>
                      <b-button v-else disabled variant="primary" class="mr-2 ml-3">Updating</b-button>
                      <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-success" v-if="updatePersonalInfoSuccessful">
                        <div class="iq-alert-text">{{ updatePersonalInfoSuccessful }}</div>
                      </div>
                      </Form>
                  </template>
                </iq-card>
              </tab-content-item>
              <tab-content-item :active="false" id="chang-pwd">
                <iq-card>
                  <template v-slot:headerTitle>
                    <h4 class="card-title">Change Password</h4>
                  </template>
                  <template v-slot:default>
                      <Form v-slot="{ errors }" :validation-schema="passwordSchema" @submit="changePassword">
                          <div class="form-group">
                            <label for="password">New Password:</label>
                            <Field name="password" class="form-control mb-0" :class="{ 'is-invalid': errors['password']}"
                            id="password" type="password" placeholder="Password"/>
                            <div class="invalid-feedback">
                              <ErrorMessage name="password" />
                            </div>
                          </div>
                           <div class="form-group">
                            <label for="repeatPassword">Repeat Password:</label>
                            <Field name="repeatPassword" class="form-control mb-0" :class="{ 'is-invalid': errors['repeatPassword']}"
                            id="repeatPassword" type="password" placeholder="Repat password"/>
                            <div class="invalid-feedback">
                              <ErrorMessage name="repeatPassword" />
                            </div>
                          </div>
                          <b-button type="submit" variant="primary" class="mr-2" :class="{ disabled: updatePasswordPending }">Submit</b-button>
                      </Form>
                       <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-success" v-if="updatePasswordSuccessful">
                        <div class="iq-alert-text">Updated Successfully. <strong>You will be logged out in 5 seconds.</strong> </div>
                      </div>
                       <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-danger" v-if="updatePasswordError">
                        <div class="iq-alert-text">{{ updatePasswordError }}</div>
                      </div>
                  </template>
                </iq-card>
              </tab-content-item>
              <tab-content-item :active="false" id="emailandsms">
                <iq-card>
                  <template v-slot:headerTitle>
                    <h4 class="card-title">Update Contacts</h4>
                  </template>
                  <template v-slot:default v-if="doctor">
                      <Form v-slot="{ errors }" @submit="updateCredentails">
                          <div class="form-group">
                            <label for="email">Email:</label>
                            <Field name="email" class="form-control mb-0" :class="{ 'is-invalid': errors['email']}"
                            id="email" type="email" :placeholder="firebaseDoctor.email"/>
                          </div>
                           <div class="form-group">
                            <label for="phone">Phone Number:</label>
                            <Field v-if="firebaseDoctor.phoneNumber" name="phone" class="form-control mb-0" :class="{ 'is-invalid': errors['phone']}"
                            id="phone" type="phoneNumber" :placeholder="firebaseDoctor.phoneNumber.slice(2)"/>
                            <Field v-else name="phone" class="form-control mb-0" :class="{ 'is-invalid': errors['phone']}"
                            id="phone" type="phoneNumber"/>
                          </div>
                          <b-button type="submit" variant="primary" class="mr-2" :class="{ disabled: updateCredentialsPending}">Submit</b-button>
                      </Form>
                      <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-danger" v-if="updateCredentailsError">
                        <div class="iq-alert-text">{{ updateCredentailsError }}</div>
                      </div>
                      <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-success" v-if="updateCredentialsSuccessful">
                        <div class="iq-alert-text">Updated Successfully. <strong>You will be logged out in 5 seconds.</strong> </div>
                      </div>
                  </template>
                </iq-card>
              </tab-content-item>
            </tab-content>
          </div>
        </b-col>
      </b-row>
    </form>
  </b-container>
</template>
<script>
import { ref, watch } from 'vue'
import { xray } from '../../config/pluginInit'
import { Field, Form, ErrorMessage } from 'vee-validate'
import * as yup from 'yup'
import firebaseService from '../../../firebase'
import getDocument from '../../services/getDocument'
import { updateDocument } from '../../services/useDocument'
import { arrayUnion } from '@firebase/firestore'
import { httpsCallable } from 'firebase/functions'
import useStorage from '../../services/useStorage'
import myUpload from 'vue-image-crop-upload'
import { useRouter } from 'vue-router'

export default {
  name: 'ProfileEdit',
  components: { Field, Form, ErrorMessage, myUpload },
  mounted () {
    xray.index()
  },
  setup () {
    const updateAuthDoctor = httpsCallable(firebaseService.functions, 'updateAuthDoctor')
    const firebaseDoctor = firebaseService.firebaseAuth.currentUser
    const { document: doctor } = getDocument('doctors', firebaseDoctor.uid)

    const { uploadError, url, uploadImage } = useStorage()
    const router = useRouter()

    // Personal Information
    const profilePic = ref(null)
    const showUpload = ref(false)
    const selectedImg = ref(null)

    const toggleShowUpload = () => {
      showUpload.value = !showUpload.value
    }

    watch(doctor, (doctorInfo) => {
      if (doctorInfo.profilePic) {
        profilePic.value = doctorInfo.profilePic
      } else {
        profilePic.value = require('../../assets/images/user/11.png')
      }
    })

    const previewImage = (imageDataUrl) => {
      showUpload.value = false
      profilePic.value = imageDataUrl
      selectedImg.value = imageDataUrl
    }

    const numberOfSpecialities = ref(1)
    const inputSpecialities = ref([{ title: '', description: '' }])

    const addAnother = () => {
      inputSpecialities.value.push({ title: '', description: '' })
      numberOfSpecialities.value++
    }

    const { updatePending, handlelUpdate, updateError } = updateDocument('doctors', firebaseDoctor.uid)

    const updatePersonalInfoSuccessful = ref(null)
    const updatePersonalInfoFailure = ref(null)

    const updatePersonalInfo = async (value) => {
      updatePersonalInfoSuccessful.value = null
      updatePending.value = true
      updatePersonalInfoFailure.value = null

      const specialities = inputSpecialities.value.filter(input => {
        return input.title.length !== 0
      })

      const data = {
        firstName: value.firstName === undefined || value.firstName.length === 0 ? doctor.value.firstName : value.firstName,
        lastName: value.lastName === undefined || value.lastName.length === 0 ? doctor.value.lastName : value.lastName,
        position: value.position === undefined
          ? doctor.value.position === undefined ? '' : doctor.value.position
          : value.position,
        gender: value.gender === undefined ? doctor.value.gender === undefined ? '' : doctor.value.gender : value.gender,
        address: value.address === undefined
          ? doctor.value.address === undefined ? '' : doctor.value.address
          : value.address,
        specialities: arrayUnion(...specialities)
      }

      if (selectedImg.value) {
        await uploadImage(selectedImg.value)
        if (!uploadError.value) {
          selectedImg.value = null
          data.profilePic = url.value
        } else {
          updatePersonalInfoFailure.value = uploadError.error
          return
        }
      }

      const info = {
        displayName: data.firstName + " " + data.lastName
      }
      updatePending.value = true
      await updateAuthDoctor({ uid: firebaseDoctor.uid, info: info })
      await handlelUpdate(data)
      if (updateError.value) {
        updatePersonalInfoFailure.value = updateError.value
        console.log(updateError.value)
        return
      }
      updatePersonalInfoSuccessful.value = 'Your personal information has been successfully updated.'
    }

    // Contact Information
    const updateCredentailsError = ref(null)
    const updateCredentialsSuccessful = ref(false)
    const updateCredentialsPending = ref(false)

    const updateCredentails = (value) => {
      updateCredentialsPending.value = true
      const info = {
        email: value.email === undefined || value.email.length === 0 ? firebaseDoctor.email : value.email,
        phoneNumber: value.phone === undefined || value.phone.length === 0 ? firebaseDoctor.phoneNumber : '+1' + value.phone
      }
      updateCredentailsError.value = null
      updateAuthDoctor({ uid: firebaseDoctor.uid, info: info })
        .then(() => {
          updateCredentialsSuccessful.value = true
          updateCredentialsPending.value = false
          setTimeout(logOutDoctor, 5000)
        }).catch(error => {
          updateCredentialsSuccessful.value = false
          updateCredentialsPending.value = false
          updateCredentailsError.value = error.message
        })
    }

    // Password
    const passwordSchema = yup.object().shape({
      password: yup.string().min(8)
        .required('This field is Required.'),
      repeatPassword: yup.string()
        .oneOf([yup.ref('password'), null], "Passwords don't match.")
        .required('This field is Required.')
    })

    const updatePasswordPending = ref(false)
    const updatePasswordError = ref(null)
    const updatePasswordSuccessful = ref(false)

    const changePassword = (value) => {
      updatePasswordPending.value = true
      updatePasswordError.value = null
      updatePasswordSuccessful.value = false
      const info = {
        password: value.password
      }
      updateAuthDoctor({ uid: firebaseDoctor.uid, info: info })
        .then(() => {
          updatePasswordPending.value = false
          updatePasswordSuccessful.value = true
          setTimeout(logOutDoctor, 5000)
        }).catch(error => {
          updatePasswordPending.value = false
          updatePasswordError.value = error.message
        })
    }

    const logOutDoctor = () => {
      firebaseService.firebaseAuth.signOut()
      router.push({ name: 'auth1.sign-in1' })
    }

    return {
      previewImage,
      changePassword,
      doctor,
      updatePersonalInfo,
      numberOfSpecialities,
      inputSpecialities,
      addAnother,
      updatePending,
      updatePersonalInfoSuccessful,
      firebaseDoctor,
      updateCredentails,
      updateCredentailsError,
      updateCredentialsSuccessful,
      updateCredentialsPending,
      passwordSchema,
      updatePasswordPending,
      updatePasswordError,
      updatePasswordSuccessful,
      profilePic,
      toggleShowUpload,
      showUpload,
      updatePersonalInfoFailure
    }
  }
}
</script>

<style scoped>
  label {
    cursor: pointer;
  }
  label i {
    color: white;
  }

  .radio {
    padding-top:10px;
  }

  .radio-input {
    margin-left: 10px;
  }

  .block {
    display: block;
  }

  .speciality-row {
    display: flex;
    align-items: flex-end;
  }

  .speciality-button {
    height: 35px;
  }

  div.alert {
    margin-top: 15px;
  }

  .btn {
    background-color: var(--light-grey);
    color: var(--text-color);
  }
</style>
